/**
 * The lab's sign-in: a portal account, and Labs' own session (the API keeps
 * one per contributor per app, so signing in here leaves the portal signed
 * in), kept in this browser under its own key.
 */
import { reactive } from 'vue'
import { Contributor } from '@/hexapla-core/domains/accounts/schema'

const KEY = 'hexapla-lab'

interface Session {
  token: string
  contributor: Contributor | null
}

const read = (): Session => {
  try {
    const own = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (own?.token) return own
  } catch {
    // Storage unavailable or unreadable: start signed out.
  }
  return { token: '', contributor: null }
}

export const session = reactive<Session>(read())

export const signIn = (token: string, contributor: Contributor) => {
  session.token = token
  session.contributor = contributor
  try {
    localStorage.setItem(KEY, JSON.stringify({ token, contributor }))
  } catch {
    // Signed in for this page only.
  }
}

export const signOut = () => {
  session.token = ''
  session.contributor = null
  try {
    localStorage.removeItem(KEY)
  } catch {
    // Nothing stored.
  }
}
